export const Languages = {
  Ar: {
    dir: "rtl",
    Navbar: {
      content: [
        "الإتصال السريع",
        "الرئيسية",
        "من نحن",
        "المنتجات",
        "الفروع ",
        "والوكلاء",
        "التواصل",
        "English",
        "الخرطوم, جنوب غرب سباق الخيل",
        "الأحد - الخميس: 3pm - 7am",
      ],
    },
    Home: {
      slide1: [
        "جياد لخدمات السيارات",
        "خدمات إحترافية بجودة عالية",
        "تعرف على خدماتنا",
      ],
      slide2: [
        "جياد لخدمات السيارات",
        "نعمل بتفاني .. لإرضاء عملائنا",
        "عرض المزيد",
      ],
      HomeProgress: ["كل المتخصصين لدينا يمتلكون أعلى درجات الخبرة والتدريب"],
      HomeAbout: {
        header: ["من", "نحن؟", "اعرف المزيد عن جياد لخدمات السيارات"],
        body: [
          "شركة جياد لخدمات السيارات المحدودة , شركة رائدة تعمل في مجال خدمات صيانة السيارات وخدمات ما بعد البيع وهي امتداد لشركة جياد لصناعة السيارات - فخر الصناعة في السودان تأسست في عام 2004 ويقع مقرها بمدينة الخرطوم جنوب غرب منطقة سباق الخيل كما أن لها فروع و وكلاء بمختلف المدن",
          "تمتلك الشركة في مقرها الرئيس ورشاً متطورة لأعمال الصيانة الميكانيكية وكهرباء السيارات ،كما تمتلك ورشة لأعمال السمكرة والطلاء والتي تقوم بتقديم خدمات تكاملية للسيارات ، بالإضافة لورشة متكاملة لخدمات الصيانة الدورية والنظافة وغيار الزيت والفلاتر",
        ],
        AboutBtn: "عرض المزيد",
      },
      HomeServices: {
        header: ["باقة", "خدماتنا", "تشكيلة من بعض الخدمات التي نقدمها"],
        body: [
          {
            title: "البيع المباشر",
            description: "خدمات البيع المباشر بمقر الشركة ومعارضها المختلفة",
            aos_dir: "fade-left",
            iconClass: "bx bxs-shopping-bag",
          },
          {
            title: "قطع الغيار الأصلية",
            description:
              "توفير قطع الغيار الأصلية (نيسان ، BYD ،هونداي، شاحنات سينو، شيري وهاو).",
            aos_dir: "fade-top",
            iconClass: "bx bxs-cog",
          },
          {
            title: "زيوت شركة جياد",
            description:
              "توفير زيوت شركة جياد وكل متعلقاتها (تروس، فرامل، شحوم وجربوكس).",
            aos_dir: "fade-right",
            iconClass: "bx bxs-droplet",
          },
          {
            title: "خدمات الضمان",
            description:
              "توفير خدمات الضمان لكل منتجات جياد من السيارات والشاحنات وفقا لشروط الضمان الخاصة بالمنتج المعني",
            aos_dir: "fade-left",
            iconClass: "bx bxs-shield-alt-2",
          },
          {
            title: "الصيانة",
            description:
              "الصيانة بمعايير عالية الجودة ومتوافقة مع شهادات ال iso ذلك بواسطة الورش المتخصصة",
            aos_dir: "fade-right",
            iconClass: "bx bxs-car-garage",
          },
          {
            title: "الاطارات",
            description:
              "توفير جميع أنواع الاطارات للسيارات والشاحنات بمختلف المقاسات",
            aos_dir: "fade-right",
            iconClass: "bx bxs-disc",
          },
        ],
      },
      HomeWhyUs: {
        header: [
          "لماذا",
          "جياد لخدمات السيارات",
          "إليك الأسباب التي ستجعلك عميلا لدينا",
        ],
        body: {
          reason1: [
            "عمال موثوقين",
            "لنا عاملين موثوقين، مثابرين، وينجزون أعمالهم في أقل فترة ممكنة، يتم عمل ورش تأهيلية لهم مما يجعلهم أكفاء",
          ],
          reason2: [
            "فعالية من حيث التكلفة",
            "خدمات متوفرة، جودة عالية، التزام في التنفيذ، ودقة في العمل، كل هذا بأقل تكلفة ممكنة",
          ],
          reason3: [
            "ارضاء 100%",
            "جميع الخدمات المقدمة تخضع لأعلى معايير الجودة والسلامة مما يجعلها الخيار الأول لتحقيق سعادة عملائنا",
          ],
        },
      },
      HomeBanner: {
        Text: ["خدمات عالية الجودة", "كن على تواصل"],
      },
      HomeQuestions: {
        header: ["الأسئلة", "الشائعة"],
        body: [
          {
            id: "headingOne",
            target: "collapseOne",
            title:
              "ما هي الخدمات والمنتجات التي تقدمها شركة جياد لخدمات السيارات",
            answers: [
              " خدمة الضمان والصيانة لمنتجات جياد لخدمات السيارات وجياد للشاحنات",
              "خدمة الصيانة لجميع السيارات",
              "مبيعات قطع الغيار",
              "مبيعات الزيوت والشحوم",
            ],
          },
          {
            id: "headingTwo",
            target: "collapseTwo",
            title: "من هم وكلاء الصيانة لدينا",
            answers: [
              "يوجد 5 وكلاء بالولايات الآتية",
              "بورتسودان",
              "الأبيض",
              "مدني",
              "القضارف",
              "كوستي",
            ],
          },
          {
            id: "headingThree",
            target: "collapseThree",
            title: "ما هى أنواع الإسبيرات المتوفرة لدى الشركة",
            answers: ["هونداي", "BYD", "سانق يونق", "هاو", "دونق فينق", "شيري"],
          },
          {
            id: "headingFour",
            target: "collapseFour",
            title: "ما هى أنواع الزيوت المتوفرة لدى الشركة",
            answers: [
              "زيوت محركات البنزين - زيوت الديزل - زيوت التروس - زيوت هايدرولك - شحوم - زيوت الفرامل - سوائل تبريد - اي زيوت خاصة اخرى",
            ],
          },
        ],
      },
      HomeClients: [
        " فروعنا المختلفة ووكلائنا المعتمدون موجودون في عدد من ولايات السودان",
        "ابحث الان",
      ],
    },
    About: {
      header: ["من نحن", "الرئيسية"],
      body1: {
        header: ["من", "نحن؟", "اعرف المزيد عن جياد لخدمات السيارات"],
        body: [
          "شركة جياد لخدمات السيارات المحدودة , شركة رائدة تعمل في مجال خدمات صيانة السيارات وخدمات ما بعد البيع وهي امتداد لشركة جياد لصناعة السيارات - فخر الصناعة في السودان تأسست في عام 2004 ويقع مقرها بمدينة الخرطوم جنوب غرب منطقة سباق الخيل كما أن له فروع وا وكلاء بمختلف المدن",
          "تمتلك الشركة في مقرها الرئيس ورشاً متطورة لأعمال الصيانة الميكانيكية وكهرباء السيارات ،كما تمتلك ورشة لأعمال السمكرة والطلاء والتي تقوم بتقديم خدمات تكاملية للسيارات ، بالإضافة لورشة متكاملة لخدمات الصيانة الدورية والنظافة وغيار الزيت والفلاتر",
        ],
      },
      body2: {
        vision: [
          "الرؤية",
          "أن نكون الرواد إقليميا في تقديم خدمات الصيانة للمركبات بمعايير عالمية",
        ],
        message: [
          "الرسالة",
          "تقديم خدمات الصيانة بمعايير عالمية مستعينين بكوادرنا المؤهلة واستخدام أحدث الأنظمة مع توفير وتوطين بعض قطع الغيار بأسعار منافسة  وعمل شراكات متميزة",
        ],
        values: [
          "القيم",
          "قيادة ملهمة",
          "العمل بروح الفريق",
          "الإلتزام",
          "صداقة مع البيئة",
          "الإبداع والابتكار",
        ],
        certificates: [
          "المميزات والشهادات",
          "تقوم الشركة بعمل كورسات لتأهيل العاملين بها",
          "للعاملين بها سوق تعاوني بأسعار مدعومة",
          "حصلت الشركة على شهادة ال ISO في العام 2006",
          "حصلت على التوكيل الحصري والأقليمي لزيوت  MAKINA LUBE 2020 في العام",
        ],
        accomplishments: [
          "الإنجازات",
          " قامت الشركة بشراكات ذكية مع  MAN الألمانية و RENAULT الفرنسية وشركات سيارات مثل هونداي و BYD الصيني",
          " لشركة جياد شراكات تشغيلية واستثمارية مع القوات المسلحة في ورشة الشجرة لصيانة الشاحنات العسكرية وإعادة تأهيل عربات الدفع  الرباعي، وورشة كافوري لصيانة العربات القيادية والوظيفية.",
          "ساهمت الشركة في دعم الأسر الفقيرة وتأهيل البنية التحتية ودعم النوادي والمنتديات الثقافية في محيط الشركة",
        ],
      },
    },
    Products: {
      header: ["المنتجات", "الرئيسية"],
      body: {
        header: ["منتجاتنا", "المميزة"],
        header2: {
          title: [
            "يمكنك الحصول على كل هذه المنتجات من خلال المقر الرئيسي لجياد أو موزعيها في الخرطوم أو الولايات الاخرى كما يتضمن خدمات التوصيل  لزبائننا الكرام",
            "ابحث عن منتج",
          ],
          oil: [
            "زيوت محركات البنزين",
            "زيوت محركات الديزل",
            "زيوت التروس",
            "سوائل التبريد",
            "زيت الهايدروليك",
            "زيت الفرامل",
            "الشحوم",
          ],
        },
        giadOils: {
          title: "زيوت جياد",
          products: [
            { title: "زيت محركات - SUPER HD PLUS - 1L", image: "oil_1.png" },
            { title: "زيت محركات - SUPER HD PLUS - 4L", image: "oil_2.png" },
            { title: "زيت محركات - UNIMAX HD PLUS - 1L", image: "oil_3.png" },
            { title: "زيت محركات - ULTRA HD PLUS - 4L", image: "oil_4.png" },
            {
              title: "زيت تروس - Tridon SUPER HD PLUS - 1L",
              image: "oil_5.png",
            },
            {
              title: "زيت تروس - Tridon SUPER HD PLUS - 4L",
              image: "oil_6.png",
            },
            { title: "زيت تبريد - ANTIFREEZE TRIDON 40%", image: "oil_7.png" },
            { title: "زيت فرامل وكلتش", image: "oil_8.png" },
          ],
        },
        filters: {
          title: "الفلاتر",
          products: [
            { title: "فلتر زيت شاحنة تراكتور", image: "f-1.png" },
            { title: "فلتر زيت بوكسي ريتش", image: "f-2.png" },
            { title: "فلتر زيت شاحنة ٣ طن", image: "f-3.png" },
            { title: "فلتر زيت نيسان باترول", image: "f-4.png" },
            { title: "فلتر زيت Hyundai i10", image: "f-5.png" },
            { title: "فلتر زيت بكاسي", image: "f-6.png" },
            { title: "فلتر ميتسوبيشي لاندروفر جاز", image: "f-7.png" },
            { title: "فلتر زيت هيونداي سينتافي", image: "f-8.png" },
            { title: "فلتر زيت BYD", image: "f-9.png" },
            { title: "فلتر زيت شاحنة بتفورد", image: "f-10.png" },
            { title: "فلتر شاحنة بتفورد جاز", image: "f-11.png" },
            { title: "فلتر زيت BYD S7 جاز", image: "f-14.png" },
            { title: "فلتر زيت بوكسي ريتش", image: "f-15.png" },
            { title: "فلتر زيت ميتسوبيشي لاندروفر", image: "f-16.png" },
          ],
        },
        batteries: {
          title: "بطاريات جياد",
          products: [
            { title: "42 AH 12V", image: "42Ah.png" },
            { title: "55 AH 12V", image: "55Ah.png" },
            { title: "60 AH 12V", image: "60Ah.png" },
            { title: "72 AH 12V", image: "72Ah.png" },
            { title: "90 AH 12V", image: "90Ah.png" },
            { title: "100 AH 12V", image: "100Ah.png" },
            { title: "120 AH 12V", image: "120Ah.png" },
            { title: "200 AH 12V", image: "200Ah.png" },
          ],
        },
      },
    },
    ServicesCenter: {
      header: ["الفروع و الوكلاء", "الرئيسية", "الفروع", "ووكلاء الشركة"],
      table: {
        thead: ["الرقم", "الولاية", "الاسم", "الموقع", "رقم الهاتف"],
        thead2: ["المراكز", " الوكلاء"],
        trC1: [
          "1",
          "ولاية البحر الاحمر",
          "مركز الموانئ الهندسية",
          "بورتسودان",
          "123112582",
        ],
        trC2: ["2", "ولاية نهر النيل", "مركز وادي النيل", "عطبرة", "123044053"],
        trC3: ["3", "ولاية الخرطوم", "مركز تبيان", "الخرطوم", "123205083"],
        trC4: ["4", "ولاية الجزيرة", "مركز مدني", "ودمدني", "123205095"],
        trC5: ["5", "دولة جنوب السودان", "مركز هاي كوالتي", "جوبا", "-"],
        trA1: ["1", "ولاية نهر النيل", "محمد شمس الدين", "عطبرة", "123462434"],
        trA2: ["2", "ولاية كسلا", "يوسف محمد ابكر", "كسلا", "126274627"],
        trA3: [
          "3",
          "الولاية الشمالية",
          "اولاد محمد علي فضل",
          "دنقلا",
          "912343353",
        ],
        trA4: ["4", "الولاية الشمالية", "اعمال بيكانتو", "الدبة", "122444990"],
        trA5: [
          "5",
          "الولاية الشمالية",
          "اعمال بشائر الخير",
          "حلفا الجديدة",
          "123500666",
        ],
        trA6: ["6", "ولاية الخرطوم", "مركز الفخامة", "امدرمان", "115978704"],
        trA7: [
          "7",
          "ولاية النيل الازرق",
          "احمد الريح",
          "الدمازين",
          "121183290",
        ],
        trA8: ["8", "ولاية النيل الابيض", "فائز سيد احمد", "سنجة", "912640231"],
        trA9: [
          "9",
          "ولاية النيل الابيض",
          "عادل عبدالرحيم المتعشي",
          "سنار",
          "123669926",
        ],
        trA10: [
          "10",
          "ولاية الجزيرة",
          "اولاد سليمان للاطارات والبطاريات",
          "ودمدني",
          "912316380",
        ],
        trA11: ["11", "ولاية الجزيرة", "اعمال الخانجي", "ودمدني", "127090002"],
      },
    },
    Contact: {
      header: ["تواصل معنا", "الرئيسية", "كن على", "إتصال"],
      body: {
        form: [
          "الاسم:",
          "الهاتف:",
          "البريد الالكتروني:",
          "الجهة:",
          "الرسالة:",
          "ارسال",
        ],
        info: [
          "رقم الهاتف",
          "الفاكس",
          "البريد الإلكتروني",
          "الموقع",
          "الخرطوم، السودان",
        ],
      },
    },
    Page404: {
      content: [
        "404",
        "الرئيسية",
        "خطأ",
        "الصفحة غير موجودة",
        "الرجوع إلى الرئيسية",
      ],
    },
    Footer: {
      content: [
        "شركة رائدة تعمل في مجال خدمات صيانة السيارات وخدمات ما بعد البيع",
        "روابط سريعة",
        "من نحن",
        "المنتجات",
        "الفروع و الوكلاء",
        "تواصل معنا",
        "التواصل",
        "الهاتف : 0120102120",
        "",
        "البريد الإلكتروني: ",
        "الخرطوم, جنوب غرب سباق الخيل",
        "تابعنا على مواقع التواصل",
        " لديك أي أسئلة؟",
        "الأحد - الخميس:  3pm - 7am",
        "كل الحقوق محفوظة ©",
        "جياد لخدمات للسيارات",
      ],
    },
  },
  En: {
    dir: "ltr",
    Navbar: {
      content: [
        "Quick call",
        "Home",
        "About",
        "Products",
        "Branches",
        " & Agents",
        "Contact",
        "العربية",
        "Khartoum, Southwest of the horse racing area",
        "Sun - Thu: 7am - 3pm",
      ],
    },
    Home: {
      slide1: [
        "Giad Motor Services",
        "High quality professional services",
        "Check our services",
      ],
      slide2: [
        "Giad Motor Services",
        "We work efficiently to satisfy you",
        "Learn more",
      ],
      HomeProgress: ["All of Our specialists ar fully trained and equiped"],
      HomeAbout: {
        header: ["Who Are", "We?", "Learn more about Giad Motor Services"],
        body: [
          "GIAD MOTOR SERVICES Co.Ltd, is a leading company working in the field of car maintenance and after-sales services, it’s an extension of GIAD Automotive industry company-the pride of industry in Sudan- established in 2004 and located in Khartoum, Southwest of the horse racing area, it also has branches and agents in various cities. ",
          "The company owns in its headquarters, advanced workshops for mechanical maintenance and car electrical works, as well as workshop for bodywork and paints, which provides integrated services for cars, in addition to an integrated services workshop for periodic maintenance services, cleaning, oil spare parts, and flats.",
        ],
        AboutBtn: "Read more",
      },
      HomeServices: {
        header: ["Our", "Services", "Here are some of our main services"],
        body: [
          {
            title: "Direct selling",
            description:
              "Direct selling services at the company’s headquarters and its various exhibitions.",
            aos_dir: "fade-left",
            iconClass: "bx bxs-shopping-bag",
          },
          {
            title: "Spares Parts",
            description:
              "Providing original spares parts (NISSAN, BYD, HYUNDAI, SINO, SHERI and HOW trucks).",
            aos_dir: "fade-top",
            iconClass: "bx bxs-cog",
          },
          {
            title: "Giad oil",
            description:
              "Providing Giad oils and all its accessories (gears,brakes, lubricants, and gearboxes).",
            aos_dir: "fade-right",
            iconClass: "bx bxs-droplet",
          },
          {
            title: "Warranty",
            description:
              " providing warranty services for all Giad products by the warranty terms of the relevant product.",
            aos_dir: "fade-left",
            iconClass: "bx bxs-shield-alt-2",
          },
          {
            title: "Maintainance",
            description:
              " providing Maintainance services with High Standard and corresponding with ISO certificate.",
            aos_dir: "fade-left",
            iconClass: "bx bxs-car-garage",
          },
          {
            title: "Wheels",
            description:
              " Provide All types of Wheels for Cars Vans Trucks, etc with all possible Sizes.",
            aos_dir: "fade-bottom",
            iconClass: "bx bxs-disc",
          },
        ],
      },
      HomeWhyUs: {
        header: [
          "Why",
          "Giad Motor Services",
          "Here is why would you choose us",
        ],
        body: {
          reason1: [
            "Trusted Workers",
            " We have reliable, persevering workers who complete their work in the shortest possible period of time. Rehabilitation are held for them, which makes them efficient.",
          ],
          reason2: [
            "Cost Effective",
            "What we look forward to is your satisfaction. Our happiness lies in your happiness. We innovate to achieve your satisfaction.",
          ],
          reason3: [
            "100% Satisfaction",
            "All services provided are subject to the highest standards of quality and safety, making it the first choice to achieve the happiness of our customers.",
          ],
        },
      },
      HomeBanner: {
        Text: ["High Quality Service", "Get in Touch"],
      },
      HomeQuestions: {
        header: ["Questions", "Frequently Asked"],
        body: [
          {
            id: "headingOne",
            target: "collapseOne",
            title: "What are the services and products we offer?",
            answers: [
              "Warranty and maintenance service for Giad products and Giad trucks",
              "maintenance service for all cars",
              "Spare parts sales",
              "Sales of oils and greases",
            ],
          },
          {
            id: "headingTwo",
            target: "collapseTwo",
            title: "Who are our maintenance agents?",
            answers: [
              "There are 5 Agents in these States",
              "Port Sudan",
              "El Obeid",
              "Madani",
              "Al Qadarif",
              "Kosti",
            ],
          },
          {
            id: "headingThree",
            target: "collapseThree",
            title: "What types of Spare Parts are available in the company?",
            answers: [
              "Hyundai",
              "BYD",
              "Ssangyong ",
              "Hao",
              "Dongfeng",
              "chery",
            ],
          },
          {
            id: "headingFour",
            target: "collapseFour",
            title: "What types of oils are available from the company?",
            answers: [
              "Gasoline engine oils - diesel oils - gear oils - hydraulic oils - greases - brake oils - coolant fluids - any other special oils.",
            ],
          },
        ],
      },
      HomeClients: [
        "Our Different barnches and authorized agents are in various states in Sudan",
        "Find One",
      ],
    },
    About: {
      header: ["About us", "Home"],
      body1: {
        header: ["Who Are", "ًWe?", "Learn more about Giad Motor Services"],
        body: [
          "GIAD MOTOR SERVICES Co.Ltd, is a leading company working in the field of car maintenance and after-sales services, it’s an extension of GIAD Automotive industry company-the pride of industry in Sudan- established in 2004 and located in Khartoum, Southwest of the horse racing area, it also has branches and agents in various cities. ",
          "The company owns in its headquarters, advanced workshops for mechanical maintenance and car electrical works, as well as workshop for bodywork and paints, which provides integrated services for cars, in addition to an integrated services workshop for periodic maintenance services, cleaning, oil spare parts, and flats.",
        ],
      },
      body2: {
        vision: [
          "Our Vision",
          "To be the regional pioneer in providing maintenance services for vehicles with international standards.",
        ],
        message: [
          "Message mission",
          "Providing maintenance services with international standards using our qualified cadres and using the latest systems with the provision and localization of some spare parts at competitive prices and the work of distinguished partnerships.",
        ],
        values: [
          "Values",
          "Inspirational leadership.",
          "Teamwork.",
          "Commitment.",
          "Friendship with the environment.",
          "Creativity and innovation.",
        ],
        certificates: [
          "Features and Certifications",
          "The company conducts training courses for its employees.",
          "There is a cooperative market at subsidized prices for the company’s workers.",
          "The company obtained the ISO certificate in the year 2006.",
          "Obtained the exclusive and regional power of attorney for MAKINA LUBE oils in the year 2020.",
        ],
        accomplishments: [
          "Achievements",
          "The company has made smart partnerships with German MAN, French RENAULT, and car companies such as HYUNDAI and China’s BYD.",
          "GIAD company has operational and investment partnerships with armed forces in the ALSHAGARA workshop for the maintenance of the military trucks and the rehabilitation of four-wheel-drive vehicles. and the KAFOURY workshop for the maintenance of leadership and functional vehicle.",
          "contributed to supporting poor families, rehabilitating infrastructure, and supporting cultural clubs and forums in the company’s vicinity.",
        ],
      },
    },
    Products: {
      header: ["Products", "Home"],
      body: {
        header: ["Our", "Featured Products"],
        header2: {
          title: [
            "You can get all these products through Giad's headquarters or its distributors in Khartoum or the other States, and it also includes delivery services to our valued customers.",
            "Search for a product",
          ],
        },
        giadOils: {
          title: "Giad Oils",
          products: [
            { title: "Engine Oil - SUPER HD PLUS - 1L", image: "oil_1.png" },
            { title: "Engine Oil - SUPER HD PLUS - 4L", image: "oil_2.png" },
            { title: "Engine Oil - UNIMAX HD PLUS - 1L", image: "oil_3.png" },
            { title: "Engine Oil - ULTRA HD PLUS - 4L", image: "oil_4.png" },
            {
              title: "Gear Oil - Tridon SUPER HD PLUS - 1L",
              image: "oil_5.png",
            },
            {
              title: "Gear Oil - Tridon SUPER HD PLUS - 4L",
              image: "oil_6.png",
            },
            { title: "ANTIFREEZE TRIDON COOLANT 40%", image: "oil_7.png" },
            { title: "BRAKE & CLUTCH FLUID", image: "oil_8.png" },
          ],
        },
        batteries: {
          title: "Giad Batteries",
          products: [
            { title: "42 AH 12V", image: "42Ah.png" },
            { title: "55 AH 12V", image: "55Ah.png" },
            { title: "60 AH 12V", image: "60Ah.png" },
            { title: "72 AH 12V", image: "72Ah.png" },
            { title: "90 AH 12V", image: "90Ah.png" },
            { title: "100 AH 12V", image: "100Ah.png" },
            { title: "120 AH 12V", image: "120Ah.png" },
            { title: "200 AH 12V", image: "200Ah.png" },
          ],
        },
        filters: {
          title: "Filters",
          products: [
            { title: "Tractor Oil Filter", image: "f-1.png" },
            { title: "Rich truck Oil filter", image: "f-2.png" },
            { title: "3 Ton's Truck Oil Filter", image: "f-3.png" },
            { title: "Nissan Patrol Oil Filter", image: "f-4.png" },
            { title: "Hyundai i10 Oil Filter", image: "f-5.png" },
            { title: "Medium Trucks Oil Filter", image: "f-6.png" },
            {
              title: "Mitsubishi landrover (gasoline) filter",
              image: "f-7.png",
            },
            { title: "Hyundai Sentafe Oil Filter", image: "f-8.png" },
            { title: "BYD Oil Filter", image: "f-9.png" },
            { title: "Bitford Truck Oil Filter", image: "f-10.png" },
            { title: "Bitford Truck (gasoline) Filter", image: "f-11.png" },
            { title: "BYD S7 (gasoline) Filter", image: "f-14.png" },
            { title: "Rich medium Truck oil filter", image: "f-15.png" },
            { title: "Mitsubishi landrover Oil Filter", image: "f-16.png" },
          ],
        },
      },
    },
    ServicesCenter: {
      header: ["Branches & Agents", "Home", "Branches", "& Agents"],
      table: {
        thead: ["number", "State", "Name", "Location", "Phone"],
        thead2: ["Centers", "Agents"],
        trC1: [
          "1",
          "Red Sea State",
          "Engineering ports Center",
          "Port Sudan",
          "123112582",
        ],
        trC2: [
          "2",
          "River Nile State",
          "Wadi-Alneel University Center",
          "Atbara",
          "123044053",
        ],
        trC3: ["3", "Khartoum State", "Tybian Center", "Khartoum", "123205083"],
        trC4: [
          "4",
          "AlJazeera State",
          "Madani Center",
          "Wd Madani",
          "123205095",
        ],
        trC5: ["5", "South Sudan Country", "High Quality Center", "Juba", "-"],
        trA1: [
          "1",
          "River Nile State",
          "Mohamed Shams Eldin",
          "Atbara",
          "123462434",
        ],
        trA2: [
          "2",
          "Kassala State",
          "Yousif Mohamed Abkar",
          "Kassala",
          "126274627",
        ],
        trA3: [
          "3",
          "North State",
          "Mohamed Ali Fadul Sons",
          "Dongla",
          "912343353",
        ],
        trA4: ["4", "North State", "PICCANTO Works", "AlDabba", "122444990"],
        trA5: [
          "5",
          "North State",
          "Bashayer AlKheir Works",
          "New Halfa",
          "123500666",
        ],
        trA6: [
          "6",
          "Khartoum State",
          "Alfakhama Center",
          "Omdurman",
          "115978704",
        ],
        trA7: [
          "7",
          "Blue Nile State",
          "Ahmed AlRayah",
          "AlDamazeen",
          "121183290",
        ],
        trA8: [
          "8",
          "White Nile State",
          "Faiz Syed Ahmed",
          "Sinja",
          "912640231",
        ],
        trA9: [
          "9",
          "White Nile State",
          "Adel Abdelrahim AlMutaashi",
          "Sinnar",
          "123669926",
        ],
        trA10: [
          "10",
          "AlJazeera State",
          "Suleiman's Sons for Tires & Batteries",
          "Wd Madani",
          "912316380",
        ],
        trA11: [
          "11",
          "Aljazeera State",
          "Alkhanji Works",
          "Wd Madani",
          "127090002",
        ],
      },
    },
    Contact: {
      header: ["Contact us", "Home", "Get In", "Touch"],
      body: {
        form: ["Name :", "Phone :", " Email :", "Party :", "Message :", "send"],
        info: ["Phone Number", "Fax", "Email", "Location", "Khartoum, Sudan"],
      },
    },
    Page404: {
      content: ["404", "Home", "ERROR", "Page not found", "Back to Homepage"],
    },
    Footer: {
      content: [
        "A Sudan based leading company working in the field of car maintenance and after-sales services.",
        "Quick Links",
        "About",
        "Products",
        "Branches & Agents",
        "Contact",
        "Contact",
        "Phone: 0120102120",
        "",
        "Email: ",
        "Khartoum, Southwest of the horse racing area.",
        "Follow Us on Social Media",
        "?Have any question",
        "Sun - Thu: 7am - 3pm",
        "All Rights Reserved ©",
        "Giad Motor Services Co",
      ],
    },
  },
};
